import React, {useEffect, useState} from 'react';
import close from "../../../images/close.svg";
import {CustomCheckBox} from "../../main/logbook/EditTable";
import image from '../../../images/man.svg'
import darkImage from '../../../images/man_white.svg'
import SendBlock from "../SendBlock/SendBlock";
import {myLicences} from "../../../redux/types";
import {useTheme} from "../../../App";
import {connect} from "react-redux";
import {getLicenses} from "../../../redux/profile/profile-thunks";
import {sendLogbook} from "../../../redux/logbook/logbook-thunks";
import {useTranslation} from "react-i18next";

const SendLogBook = ({closeModal, isDark, ...props}) => {
  const [emails, setEmails] = useState([])
  const [licences, setLicences] = useState(null)
  const [isShowResume, setIsShowResume] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [message, setMessage] = useState('')
  const {t} = useTranslation()
  useEffect(() => {
    props.getLicenses()
  }, [])
  return (
    <div style={{width: 520}} className={`modal ${isDark && 'modal__dark'}`}>
      <button onClick={closeModal} className="modal__close">
        <img src={close} alt=""/>
      </button>
      <h5 className="modal__title mr-30">{t('sendLog')}</h5>
      {!isSubmitted ? <>
        <div className={'modal__sections'}>
          <div className="modal__section">
            <SendBlock emails={emails} setEmails={setEmails}/>
          </div>
          <div className="modal__section">
            {props.licenses !== null && <>
              <CustomCheckBox isDark={isDark} caption={t('attachLicenses')} onClick={() => {
                if (licences === null) {
                  setLicences(props.licenses.map(l => l.id))
                } else {
                  setLicences(null)
                }
              }} isChecked={licences !== null} fontFamily={'Lato500'} color={'#252526'}/>
              {licences !== null && <div className="ml-24">
                {props.licenses.map((l, index) => <CustomCheckBox isDark={isDark} key={index}
                                                                  caption={`${l.license_system?.name}, ${l.license_type?.name}, ${l.license_number}, ${l.issue_date}`}
                                                                  isChecked={licences.indexOf(l.id) !== -1}
                                                                  onClick={() => {
                                                                    if (licences.indexOf(l.id) !== -1) {
                                                                      setLicences([...licences].filter(li => li !== l.id))
                                                                    } else {
                                                                      setLicences([...licences, l.id])
                                                                    }
                                                                  }}
                                                                  fontFamily={'Lato500'} color={'#252526'}/>)}
              </div>}
            </>}
            <CustomCheckBox isDark={isDark} caption={t('attachSailResume')}
                            isChecked={isShowResume} onClick={() => setIsShowResume(!isShowResume)}
                            fontFamily={'Lato500'} color={'#252526'} marginBottom={'0px'}/>
          </div>
          <div className="mt-24">
            <p style={{fontFamily: 'Lato700'}} className="modal__text mb-12">{t('messageToRecepient')}:</p>
            <div className="modal__textareaItem w-100 mt-0">
          <textarea id={'text'} value={message} onChange={e => setMessage(e.target.value)}
                    placeholder={t('messageToRecepientLogbookHolder')} autoComplete={'off'}
                    className="modal__textarea w-100"/>
            </div>
            <div className="modal__linkWrapper mt-24">
              <p className="modal__link">
                https://online-logbook.eu/logbook/share/
              </p>
              <button className="modal__copy">
                {t('copyLink')}
              </button>
            </div>
          </div>
        </div>
        <div className="modal__buttons">
          <div className="modal__actions">
            <button disabled={emails.length === 0} onClick={() => {
              console.log({
                recipients: emails,
                licences,
                message,
                is_attach_resume: isShowResume,
                fields: props.fields.map(f => f.type),
                trips: props.trips.map(t => t.id)
              })
              props.sendLogbook({
                recipients: emails,
                licences,
                message,
                is_attach_resume: isShowResume,
                fields: props.fields.map(f => f.type),
                trips: props.trips.map(t => t.id)
              })
              setIsSubmitted(true)
            }}
                    className={`submit-button ${emails.length === 0 && 'submit-button__disabled'}`}>
              {t('send')}
            </button>
            <button onClick={closeModal} className={`commonBtn ${isDark && 'commonBtn__dark'}`}>
              <span className={'commonBtn__label'}>{t('cancel')}</span>
            </button>
          </div>
        </div>
      </> : <div className={'modal__row flex-end'}>
        <img src={isDark ? darkImage : image} alt=""/>
        <div className="modal__details">
          <p className="modal__underTitle">
            {t('fine')}
          </p>
          <p className="modal__detailsText">{t('logbookSended')}</p>
          <p className="modal__emails">
            {emails.map(e => <>
              {e} <br></br>
            </>)}
          </p>
          <button onClick={closeModal} className="submit-button">
            {t('excellent')}
          </button>
        </div>
      </div>}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => ({
  licenses: state.profileReducer.licenses,
  trips: state.logbookReducer.trips,
})

export default connect(mapStateToProps, {getLicenses, sendLogbook})(React.memo(SendLogBook))
